import React from "react"

import { Control } from "react-hook-form"

import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Switch } from "@/components/ui/switch"

import { FormInput, FormValues } from "./ReviewFormSchema"

interface AttendedToggleSectionProps {
  control: Control<FormInput, unknown, FormValues>
}

const AttendedToggleSection: React.FC<AttendedToggleSectionProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="attended"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3">
          <div className="space-y-0.5">
            <FormLabel className="text-base">Driver Attended</FormLabel>
          </div>
          <FormControl>
            <Switch checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default AttendedToggleSection
